// extracted by mini-css-extract-plugin
module.exports = {"Recaptcha":"Recaptcha_Recaptcha__kyEUn","Input":"Recaptcha_Input__F8cY_","AriaDescription":"Recaptcha_AriaDescription__PNb-6"};